export async function initFirebase(): Promise<void> {}

export function logCrashlyticsError(_error: Error, _context?: string): void {}

export function setCrashlyticsUserId(_userId: string): void {}

export function logCrashlytics(_message: string): void {}

export async function logAnalyticsEvent(
  _name: string,
  _params?: Record<string, unknown>
): Promise<void> {}
